@if (readonlytextHtml()) {
    <div class="modal-panel"><p [innerHTML]="readonlytextHtml()"></p></div>
}
@for (row of rows(); track row; let first = $first) {
    <div class="modal-panel modal-panel-input">
        <div class="ta-toolbar btn-toolbar" [class.focussed]="first" [class.ng-hide]="!first">
            <!-- The app builds with preserveWhitespaces:true, and these buttons are inline-block:
                 any text node between them paints a ~4px gap. v1 textAngular appended the buttons
                 via DOM (no text nodes), so the @for/@if blocks below must stay gapless. -->
            <div class="btn-group">@for (btn of toolbarButtons(); track btn) {<button
                        type="button"
                        class="btn btn-default"
                        [attr.name]="btn.name"
                        [attr.title]="btn.title"
                        tabindex="-1"
                        unselectable="on"
                        [class.active]="btn.name === 'html' ? !!row.sourceView : !!commandStates()[btn.name]"
                        [disabled]="!!row.sourceView && btn.name !== 'html'"
                        (mousedown)="$event.preventDefault()"
                        (click)="onToolbarButton($event, btn.name, row)"
                    ><i [class]="btn.icon"></i></button>}@if (hasTokens()) {<div class="insert-token ft-dropdown opens-left btn btn-default" unselectable="on"
                        [class.active]="tokenMenuOpen()"
                        (mousedown)="$event.preventDefault()"
                        (click)="toggleTokenMenu($event)"
                    ><div class="ft-dropdown-toggle">Insert Token <i class="ft-icn-caret-down"></i></div><ul class="ft-dropdown-menu ft-toolbar-menu">@for (token of tokens(); track token) {<li><a (mousedown)="$event.preventDefault()" (click)="insertToken($event, token, row)">{{ token.text || token }}</a></li>}</ul></div>}</div>
        </div>

        @for (field of normalizedFields(); track field) {
            <div class="field">
                <div class="ft-label" [innerHTML]="field.label || ''"></div>
                <div class="ta-root" [class.focussed]="first" [style.direction]="isRtl(row.language) ? 'rtl' : 'ltr'">
                    <div class="ta-scroll-window ta-text ta-editor form-control" [class.ng-hide]="!!row.sourceView">
                        <!-- textAngular's static popover + resize-overlay skeleton (textAngular.js
                             displayElements) — never activated here, but it paints a 2px artifact
                             under the toolbar that the pixel gate sees. -->
                        <div class="popover fade bottom" style="max-width: none; width: 305px">
                            <div class="arrow"></div>
                            <div class="popover-content"></div>
                        </div>
                        <div class="ta-resizer-handle-overlay">
                            <div class="ta-resizer-handle-background"></div>
                            <div class="ta-resizer-handle-corner ta-resizer-handle-corner-tl"></div>
                            <div class="ta-resizer-handle-corner ta-resizer-handle-corner-tr"></div>
                            <div class="ta-resizer-handle-corner ta-resizer-handle-corner-bl"></div>
                            <div class="ta-resizer-handle-corner ta-resizer-handle-corner-br"></div>
                            <div class="ta-resizer-handle-info"></div>
                        </div>
                        <div
                            contenteditable="true"
                            class="ta-bind"
                            [innerHTML]="row.html[field.name]"
                            (input)="onInput($event, row.fieldData, field.name)"
                        ></div>
                    </div>
                    <textarea class="ta-bind ta-html ta-editor form-control" [class.ng-hide]="!row.sourceView" (input)="onSourceInput($event, row)"></textarea>
                    <input type="hidden" tabindex="-1" style="display: none" [value]="row.fieldData[field.name] || ''" />
                </div>
                <input type="text" class="ng-hide" hidden [value]="row.fieldData[field.name] || ''" />
            </div>
        }

        @if (languages().length > 1) {
            <div class="language-code">{{ row.language.name }}</div>
        }
    </div>
}
